import { color1Default, color2Default } from './colors'
import type { IOptions, RecursivePartial } from 'tsparticles-engine'

export function getSideConfettisConfig(
  color1: string = color1Default,
  color2: string = color2Default,
): RecursivePartial<IOptions> {
  return {
    fullScreen: {
      zIndex: 1,
    },
    emitters: [
      {
        life: {
          count: 1,
          duration: 3,
          delay: 0,
        },
        position: {
          x: 0,
          y: 30,
        },
        rate: {
          quantity: 5,
          delay: 0.1,
        },
        particles: {
          size: {
            value: {
              min: 2,
              max: 8,
            },
          },
          move: {
            direction: 'topRight',
            outModes: {
              top: 'none',
              left: 'none',
              default: 'destroy',
            },
          },
        },
      },

      {
        life: {
          count: 1,
          duration: 3,
          delay: 0,
        },
        position: {
          x: 100,
          y: 30,
        },
        rate: {
          quantity: 5,
          delay: 0.1,
        },
        particles: {
          size: {
            value: {
              min: 2,
              max: 8,
            },
          },
          move: {
            direction: 'topLeft',
            outModes: {
              top: 'none',
              right: 'none',
              default: 'destroy',
            },
          },
        },
      },

      {
        life: {
          count: 1,
          delay: 3,
        },
        position: {
          x: 0,
          y: 30,
        },
        rate: {
          quantity: 3,
          delay: 0.1,
        },
        particles: {
          move: {
            direction: 'topRight',
            outModes: {
              top: 'none',
              left: 'none',
              default: 'destroy',
            },
          },
        },
      },

      {
        life: {
          count: 1,
          delay: 3,
        },
        position: {
          x: 100,
          y: 30,
        },
        rate: {
          quantity: 3,
          delay: 0.1,
        },
        particles: {
          move: {
            direction: 'topLeft',
            outModes: {
              top: 'none',
              right: 'none',
              default: 'destroy',
            },
          },
        },
      },
    ],
    particles: {
      color: {
        value: [color1, color2, '#763DD3'],
      },
      move: {
        decay: 0.05,
        direction: 'top',
        enable: true,
        gravity: {
          enable: true,
        },
        outModes: {
          top: 'none',
          default: 'destroy',
        },
        speed: {
          min: 5,
          max: 45,
        },
      },
      number: {
        value: 0,
      },
      opacity: {
        value: 1,
      },
      rotate: {
        value: {
          min: 0,
          max: 360,
        },
        direction: 'random',
        animation: {
          enable: true,
          speed: 30,
        },
      },
      tilt: {
        direction: 'random',
        enable: true,
        value: {
          min: 0,
          max: 360,
        },
        animation: {
          enable: true,
          speed: 30,
        },
      },
      size: {
        value: {
          min: 1,
          max: 4,
        },
        animation: {
          enable: true,
          startValue: 'min',
          count: 1,
          speed: 16,
          sync: true,
        },
      },
      roll: {
        darken: {
          enable: true,
          value: 25,
        },
        enable: true,
        speed: {
          min: 5,
          max: 15,
        },
      },
      wobble: {
        distance: 30,
        enable: true,
        speed: {
          min: -7,
          max: 7,
        },
      },
      shape: {
        type: ['circle', 'square'],
        options: {},
      },
    },
  }
}
